<template>
  <div class="main mainIndicateur1 mainIndicateur2 mainIndicateur20">
      <div class="testT-section sectionCI sectionCI1">
           <ul class="ul-corpus ulInd2V2">
                <div class="ind-bloc1">
                  <li v-for="(part, index) in parts1" :key="part.name" v-on:click="onClick(index, parts1)" :class="[part.active === true ? 'ind-active' : '']"> {{  part.name }} </li>
                </div>
                <div class="ind-bloc2">
                  <div class="imgb2" >
                    <img v-if="user.sexe == 'femme'" src="../../assets/logo/Silhouettes-Femme.svg" alt="schema corps humain feminin"/>
                    <img v-if="user.sexe == 'homme'" src="../../assets/logo/Silhouettes-Homme.svg" alt="schema corps humain masculin"/>
                    <!--<div class="puceb2">-->
                      <canvas width='20px' height='20px' class="puceHumain" id="Tete1" v-if="parts1[0].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Tete2" v-if="parts1[0].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Dorsale" v-if="parts1[1].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Lombaire" v-if="parts1[2].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Bassin1" v-if="parts1[3].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Bassin2" v-if="parts1[3].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Pied1" v-if="parts2[0].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Pied2" v-if="parts2[0].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Epaule1" v-if="parts3[0].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Epaule2" v-if="parts3[0].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Coude1" v-if="parts3[1].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Coude2" v-if="parts3[1].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Mains1" v-if="parts3[2].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Mains2" v-if="parts3[2].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Genoux1" v-if="parts3[3].active == true"></canvas>
                    <canvas width='20px' height='20px' class="puceHumain" id="Genoux2" v-if="parts3[3].active == true"></canvas>
                    <!--</div>-->
                  </div>
                  <li v-for="(part, index) in parts2" :key="part.name" v-on:click="onClick(index, parts2)" :class="[part.active === true ? 'ind-active': '']"> {{  part.name }}  </li></div>
                <div class="ind-bloc3"><li v-for="(part, index) in parts3" :key="part.name" v-on:click="onClick(index, parts3)" :class="[part.active === true ? 'ind-active' : '']"> {{  part.name }}  </li></div>
            </ul>
      </div>
      
  </div>
</template>

<script>
export default {
  name: "Indicateur_2",
  data() {
    return {
        parts1: [{ name: 'Tête & Cervicales', active: false }, { name: 'Dorsales', active: false }, { name: 'Lombaires', active: false },{ name: 'Bassin & Hanches', active: false }],
        parts2: [{ name: 'Chevilles & Pieds', active: false }],
        parts3: [{ name: 'Epaules', active: false }, { name: 'Coudes', active: false }, { name: 'Poignets & Mains', active: false }, { name: 'Genoux', active: false }],
        user: JSON.parse(localStorage.user)|| [],
        arrayPuce: [],
        glob: 0.4,
        animationDelay: 250,
        click: 'add',
    };
  },
  created(){
    if (typeof(localStorage.user) !== undefined){
      this.user = JSON.parse(localStorage.user);
      this.indicateur = this.user.cI;
      if (this.indicateur !== null && this.indicateur[1] !== undefined){
        this.indicateur = this.indicateur[1];
      }else{
        this.indicateur = null;
      }
      
        

    }
    //console.log(this.indicateur/*, this.arrayPuce*/);
  },
  methods: {
    onClick(index, array){
      if (array[index].active == false){
         array[index].active= true;
         this.click = 'add';
      }else {
        array[index].active= false;
        this.click = 'del';
      }
      //this.draw();
    },
    hallo(glob){
      if (glob < 0.8 && glob > 0.3){
        return this.glob = glob + 0.1;
      }else{
        return this.glob = 0.4
      }
    },
    draw(){
            //var ctx = document.getElementById('Tete1');
    var time = new Date();
    //setInterval(this.hallo(this.glob), 1000)
    var ctxs = document.getElementsByClassName('puceHumain');
      for (let c of ctxs){
                          
        let ctx = c.getContext("2d");
        
        
        if (ctx !== null && this.arrayPuce.indexOf(c) == -1){

        // draw background
        ctx.fillStyle = '#c41316';
        // règle la valeur de transparence
        
        ctx.globalAlpha = this.glob;
        // Dessine des cercles semi-transparents
          for (let i = 0; i < 2; i++) {
          ctx.beginPath();
          ctx.arc(10, 10, 5 + 3 * i, 0, Math.PI * 2, true);
          ctx.fill();
        }
        this.arrayPuce.push(c);
      }else if (this.arrayPuce.indexOf(c) != -1 && this.click == 'del'){
        delete this.arrayPuce.indexOf(c);
      }
    }
    }
    
},
mounted(){
      if (this.indicateur !== null){
        this.parts1.forEach(element => {
        this.indicateur.resultat.forEach(elemen1 => {
          if (String(element.name) == String(elemen1).trim()){
            element.active = true;
          }
          this.draw();
        })
      });
      this.parts2.forEach(element => {
        this.indicateur.resultat.forEach(elemen1 => {
          if (String(element.name) == String(elemen1).trim()){
            element.active = true;
          }
          this.draw();
        })
      });
      this.parts3.forEach(element => {
        this.indicateur.resultat.forEach(elemen1 => {
          if (String(element.name) == String(elemen1).trim()){
            element.active = true;
          }
          this.draw();
        })
      });
      }
},
updated() {
    //var ctx = document.getElementById('Tete1');
    var time = new Date();
    //setInterval(this.hallo(this.glob), 1000)
    var ctxs = document.getElementsByClassName('puceHumain');
      for (let c of ctxs){
                          
        let ctx = c.getContext("2d");
        
        
        if (ctx !== null && this.arrayPuce.indexOf(c) == -1){

        // draw background
        ctx.fillStyle = '#c41316';
        // règle la valeur de transparence
        
        ctx.globalAlpha = this.glob;
        // Dessine des cercles semi-transparents
          for (let i = 0; i < 2; i++) {
          ctx.beginPath();
          ctx.arc(10, 10, 5 + 3 * i, 0, Math.PI * 2, true);
          ctx.fill();
        }
        this.arrayPuce.push(c);
      }else if (this.arrayPuce.indexOf(c) != -1 && this.click == 'del'){
        delete this.arrayPuce.indexOf(c);
      }
    }
  },
};
</script>

<style>
 .sectionCI1{
   display: block;
   padding-bottom: 20px;
 }
 .mainIndicateur2{
   overflow: visible;
 }
 .sectionCI1 ul{
   min-height: 210px !important;
   height: 33vh;
 }
 .mainIndicateur20{
  background-color: rgba(255, 255, 255, 0.7);
   border-radius: 8px 8px 8px 8px;
   height: 54vh;
   
 }
 @media screen and (min-width: 1700px){
   .imgb2{
     max-width: 200px;
     max-height: 230px;
   }
   #Tete1 {
        top: 0px;
        right: 129px;
    }
    #Tete2 {
        top: 14px;
        right: 51px;
    }
    #Dorsale {
        top: 44px;
        right: 51px;
    }
    #Lombaire {
        top: 78px;
        right: 51px;
    }
    #Bassin1 {
        top: 94px;
        right: 118px;
    }
    #Bassin2 {
        top: 94px;
        right: 43px;
    }
    #Pied1 {
        top: 202px;
        right: 129px;
    }
    #Pied2 {
        top: 208px;
        right: 50px;
    }
    #Epaule1 {
        top: 37px;
        right: 150px;
    }
    #Epaule2 {
        top: 37px;
        right: 30px;
    }
    #Coude1 {
        top: 75px;
        right: 160px;
    }
    #Coude2 {
        top: 75px;
        right: 18px;
    }
    #Mains1 {
        top: 100px;
        right: 168px;
    }
    #Mains2 {
        top: 110px;
        right: 8px;
    }
    #Genoux1 {
        top: 152px;
        right: 129px;
    }
    #Genoux2 {
        top: 152px;
        right: 50px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/indicateur/Indicateur_2.vue